import React, { useEffect, useState } from 'react';
import { designBaseUrl } from '../../lib/FL';
import BukkenListPreview from './BukkenListPreview';
import BukkenDetailPreview from './BukkenDetailPreview';
import { BukkenMapPreview } from './BukkenMapPreview';

import styles from './ContentPreview.module.scss';

// @todo
// 特殊対応なんとかしたい
// サンプル表示ページ｜コンテンツ下に出す共通パーツ名
const COMMON_BOTTOM_PARTS: { [key: string]: string } = {
  form: 'btn_form_submit',
  recruit: 'btn_cms_pagenavi',
  seminar_detail: 'btn_form_submit',
  form_appointment: 'btn_form_submit',
  form_assessment: 'btn_form_submit',
  form_loan: 'btn_form_submit',
  'form_request-rent': 'btn_form_submit',
  'form_request-sale': 'btn_form_submit',
  'form_request-invest': 'btn_form_submit',
  'form_request-tenant': 'btn_form_submit',
  form_leave: 'btn_form_submit',
  form_trouble: 'btn_form_submit',
};

type Props = {
  contentEnName: string;
  device: string;
  isDetail: boolean;
};

const ContentPreview: React.FC<Props> = ({ contentEnName, device, isDetail }) => {
  const commonImageDirUrl = `${designBaseUrl}/assets/formatline/design/${device}/contents/common`;
  const headerImageUrl = `${commonImageDirUrl}/header.png`;
  const footerImageUrl = `${commonImageDirUrl}/footer.png`;
  const contentEnNameWithDetail = contentEnName + (isDetail ? '_detail' : '');
  const imageDirUrl = `${designBaseUrl}/assets_resized/formatline/design/${device}/contents/${contentEnNameWithDetail}`;

  const [extraImagePaths, setExtraImagePaths] = useState<string[]>([]);
  useEffect(() => {
    const getExtraImagePaths = async () => {
      const paths: string[] = [];
      for (let i = 1; i < 20; i += 1) {
        const path = `/sample${i === 1 ? '' : `_${String(i).padStart(2, '0')}`}.png`;
        const isExistSample = await fetch(imageDirUrl + path).then((response) => response.ok);
        if (isExistSample) {
          paths.push(path);
        } else {
          break;
        }
      }
      setExtraImagePaths(paths);
    };
    getExtraImagePaths();
  }, [imageDirUrl, setExtraImagePaths]);

  if (contentEnName === 'list') {
    if (isDetail) {
      return <BukkenDetailPreview device={device} />;
    }
    return <BukkenListPreview device={device} />;
  }

  if (contentEnName === 'map') {
    return <BukkenMapPreview device={device} />;
  }

  return (
    <div className={styles.content}>
      <header className={styles.content__header}>
        <img src={headerImageUrl} alt='ヘッダー' />
      </header>
      <ul>
        {extraImagePaths.map((path) => (
          <li key={path}>
            <img src={imageDirUrl + path} alt='サンプル画像' crossOrigin='anonymous' />
          </li>
        ))}
        {contentEnNameWithDetail in COMMON_BOTTOM_PARTS && (
          <li>
            <img src={`${commonImageDirUrl}/${COMMON_BOTTOM_PARTS[contentEnNameWithDetail]}.png`} alt='サンプル画像' />
          </li>
        )}
      </ul>
      <footer>
        <img src={footerImageUrl} alt='フッター' />
      </footer>
    </div>
  );
};

export default ContentPreview;
